import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { UserRolesConditionEnum } from '@isl-core/enums/user-roles.enum'
import { UserService } from '@isl-core/services/user.service'
import { AuthGuardData, createAuthGuard } from 'keycloak-angular'

const isAccessAllowed = async (
    route: ActivatedRouteSnapshot,
    _: RouterStateSnapshot,
    authData: AuthGuardData
): Promise<boolean | UrlTree> => {
    const { authenticated } = authData
    const userService = inject(UserService)
    const router = inject(Router)

    // Get the roles required from the route
    let routePermissions = route.data['permission'] || { roles: [], condition: 'all' }

    if (!authenticated) {
        return false
    }

    // Check for children if empty
    if (route.children.length > 0) {
        routePermissions = route.children[0].data['permission'] || { roles: [], condition: 'all' }
    }

    // Allow the user to proceed if no additional roles are required to access the route
    if (routePermissions.roles.length === 0) {
        return true
    }

    if (routePermissions.condition === UserRolesConditionEnum.Any) {
        // Allow the user to proceed if at least one required role are present
        if (userService.hasAnyRole(routePermissions.roles)) {
            return true
        }
    }

    if (routePermissions.condition === UserRolesConditionEnum.All) {
        // Allow the user to proceed if all the required roles are present
        if (userService.hasRoles(routePermissions.roles)) {
            return true
        }
    }

    // User doesn't have enough permission
    router.navigate(['/error/403'])
    return false
}

export const AuthGuard = createAuthGuard<CanActivateFn>(isAccessAllowed)
